import { useState } from "react";

import styled from "styled-components";

import YaMap from "../tools/YaMap";

import PopUpWrapper from "components/modals/modal-wrapper";

import useModal from "hooks/useModal";

import { EModals } from "types/enums";

const MapModal = () => {
    const [dormitories, setDormitories] = useState([]);
    const {} = useModal(EModals.Map, { onOpen: (d) => setDormitories(d) });
    return (
        <PopUpWrapper name={EModals.Map} extra="max-width: fit-content; overflow: hidden; padding: 0; margin-top: 10px;">
            <MapPlaceholder>
                <YaMap
                    dorms={dormitories}
                    onSelect={(x) => {
                        console.log("onSelect! x = ", x);
                        try {
                            window.open(`/dormitory/${x.id}`, "_blank").focus();
                        } catch (exc) {}
                    }}
                />
            </MapPlaceholder>
        </PopUpWrapper>
    );
};

const MapPlaceholder = styled.div`
    width: 80vw;
    height: 80vh;
`;

export default MapModal;

//
// import { useEffect, useState } from "react";
// import { render } from "react-dom";
// import styled from "styled-components";
// import _ from "lodash";
// import { YMaps, Map, Placemark } from "react-yandex-maps";

// import PopUpWrapper from "./modal-wrapper";
// import { Frame, Form, Row, Button } from "components/ui-kit/styled-templates";

// import useModal from "hooks/useModal";

// import { EModals } from "types/enums";

// const MapModal = () => {
//     const [universities, setUniversities] = useState([]);

//     const { close, state: modalState = {} } = useModal(EModals.Map, { onOpen: setUniversities });
//     const { mode, data } = modalState;

//     const size = {
//         width: Math.min(...[1000, window.innerWidth * 0.9, window.innerHeight * 0.9]),
//         height: Math.min(...[1000, window.innerWidth * 0.9, window.innerHeight * 0.9]),
//     };

//     const handlers = {
//         createBalloon: (id: string) => () => {
//             setTimeout(() => {
//                 // const nodes = Array.from(document.getElementsByClassName("ymaps-2-1-79-islets_icon-with-caption__caption-block"));
//                 // nodes.forEach((node) => {
//                 //     _.set(node, "style.transform", "translate(calc(-50% + 16px), calc(-100% + 22px))");
//                 //     node.classList.remove("ymaps-2-1-79-islets_icon-caption");
//                 //     render(<UniTab.Component />, node);
//                 // });

//                 // const pointers = Array.from(document.getElementsByClassName("ymaps-2-1-79-svg-icon"));
//                 // pointers.forEach((pointer) => {
//                 //     _.set(pointer, "style.background", "unset");
//                 //     render(
//                 //         <MapIcon
//                 //             onClick={() => {
//                 //             }}
//                 //         />,
//                 //         pointer
//                 //     );
//                 // });
//             }, 0);
//         },
//     };

//     return (
//         <PopUpWrapper name={EModals.Map} extra="max-width: fit-content;">
//             <YMaps>
//                 <Map {...size} defaultState={{ center: [55.75, 37.57], zoom: 9 }}>
//                     {universities.map((uni, index) => {
//                         const value = {
//                             lat: +_.get(uni, "details.main-info.coordinates.lat"),
//                             lng: +_.get(uni, "details.main-info.coordinates.lng"),
//                         };
//                         return (
//                             <Placemark
//                                 key={index}
//                                 geometry={[value.lat ? +value.lat : 55.75, value.lng ? +value.lng : 37.57]}
//                                 onLoad={handlers.createBalloon(uni?.id)}
//                             />
//                         );
//                     })}
//                 </Map>
//             </YMaps>
//         </PopUpWrapper>
//     );
// };

// const MapIcon = styled(Frame)`
//     width: 22px;
//     height: 33px;
//     background: url("${require(`assets/icons/map-pointer.svg`).default}") no-repeat center center / contain;
// `;

// const UniTab = {
//     Component: () => {
//         return (
//             <UniTab.Wrapper>
//                 <UniTab.Photo />
//                 <UniTab.Content>
//                     <i>Название объекта</i>
//                 </UniTab.Content>
//             </UniTab.Wrapper>
//         );
//     },
//     Wrapper: styled(Frame)`
//         background: #fff;
//         border: 1px solid #e3ecf4;
//         box-shadow: 0px 20px 40px rgba(191, 197, 204, 0.2);
//         border-radius: 12px;
//         overflow: hidden;
//     `,
//     Photo: styled(Frame)`
//         width: 327px;
//         height: 150px;
//         background: grey;
//     `,
//     Content: styled(Frame)`
//         width: 100%;
//         padding: 16px 20px;
//         box-sizing: border-box;
//         align-items: flex-start;
//     `,
// };

// export default MapModal;
//
